import { useState, useEffect, useCallback } from 'react'
import { notificacaoService } from '../services/notificacaoService'
import { browserNotificationService } from '../services/browserNotificationService'
import { websocketService } from '../services/websocketService'
import { useAuthStore } from '../store/authStore'
import { useNotificationStore } from '../store/notificationStore'

export function useNotifications() {
  const notificacoes = useNotificationStore((state) => state.notificacoes)
  const naoLidas = useNotificationStore((state) => state.naoLidas)
  const setNotificacoes = useNotificationStore((state) => state.setNotificacoes)
  const setNaoLidas = useNotificationStore((state) => state.setNaoLidas)
  const marcarComoLidaLocal = useNotificationStore((state) => state.marcarComoLidaLocal)
  const marcarTodasLidasLocal = useNotificationStore((state) => state.marcarTodasLidasLocal)
  
  const [loading, setLoading] = useState(false)
  const [wsConnected, setWsConnected] = useState(false)
  const { isAuthenticated } = useAuthStore()

  const loadNotificacoes = useCallback(async () => {
    if (!isAuthenticated) return

    try {
      setLoading(true)
      const response = await notificacaoService.getAll({ limit: 50 })
      setNotificacoes(response.data)
      setNaoLidas(response.naoLidas)
    } catch (error) {
      console.error('Erro ao carregar notificações:', error)
    } finally {
      setLoading(false)
    }
  }, [isAuthenticated, setNotificacoes, setNaoLidas])

  const marcarComoLida = useCallback(async (id: string) => {
    try {
      await notificacaoService.marcarComoLida(id)
      marcarComoLidaLocal(id)
    } catch (error) {
      console.error('Erro ao marcar notificação como lida:', error)
    }
  }, [marcarComoLidaLocal])

  const marcarTodasLidas = useCallback(async () => {
    try {
      await notificacaoService.marcarTodasLidas()
      marcarTodasLidasLocal()
    } catch (error) {
      console.error('Erro ao marcar todas como lidas:', error)
    }
  }, [marcarTodasLidasLocal])

  const requestBrowserPermission = useCallback(async () => {
    const permission = await browserNotificationService.requestPermission()
    return permission === 'granted'
  }, [])

  useEffect(() => {
    if (!isAuthenticated) return

    loadNotificacoes()

    const connectionCheck = setInterval(() => {
      setWsConnected(websocketService.isConnected())
    }, 3000)

    setWsConnected(websocketService.isConnected())

    return () => {
      clearInterval(connectionCheck)
    }
  }, [isAuthenticated, loadNotificacoes])

  return {
    notificacoes,
    naoLidas,
    loading,
    wsConnected,
    loadNotificacoes,
    marcarComoLida,
    marcarTodasLidas,
    requestBrowserPermission,
    isBrowserNotificationEnabled: browserNotificationService.isEnabled(),
  }
}
